<template>
  <service-form
    v-model="form"
    :available-specialists="available_specialists"
    :category-options="category_options"
    class="w-full bg-white"
    @submit="submit"
  >
    <div
      class="flex items-center justify-end border-t border-gray-200 bg-gray-100 px-6 py-4"
    >
      <loading-button
        :loading="form.processing"
        class="btn-indigo"
        type="submit"
      >
        Utwórz usługę
      </loading-button>
    </div>
  </service-form>
</template>

<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useForm } from '@inertiajs/vue3';
import LoadingButton from '@/Shared/LoadingButton.vue';
import ServiceForm from './Form.vue';
import { createServiceRouteHelper } from '@/utils/createServiceRouteHelper';

const { proxy } = getCurrentInstance();
const routes = proxy.$routes;

defineProps({
  // eslint-disable-next-line vue/prop-name-casing
  available_specialists: {
    type: Array,
    default: () => [],
  },
  // eslint-disable-next-line vue/prop-name-casing
  category_options: {
    type: Array,
    default: () => [],
  },
});

const form = useForm({
  service: {
    active: true,
    category: null,
    use_local_name: false,
    specialist_ids: [],
    data_pl: { name: '', description: '', important_information: [], faq: [] },
    data_en: { name: '', description: '', important_information: [], faq: [] },
  },
});

const serviceRoutes = computed(() => createServiceRouteHelper(null, routes));

const emit = defineEmits(['success']);

const submit = () => {
  form.post(serviceRoutes.value.index(), {
    onFinish: () => {
      if (!form.hasErrors) {
        form.reset();
        form.service.active = true;
        form.service.category = null;
        form.service.specialist_ids = [];
      }
    },
    onSuccess: () => {
      emit('success');
    },
    onError: () => {},
  });
};
</script>
